import { Page } from "../page/page.model";

/**
 * @deprecated use getCulturedSlugs instead.
 */
export function getSlugs(pages: Page[]): Record<string, string[]> {
	const result: Record<string, string[]> = {};

	for (const page of pages) {
		for (const translation of page.translatedRoutes) {
			const locale = result[translation.languageCode] || [];
			locale.push(translation.path);
			result[translation.languageCode] = locale;
		}
	}

	return result;
}

export function getCulturedSlugs(pages: Page[]): Record<string, { culture: string; urls: string[] }> {
	const result: Record<string, { culture: string; urls: string[] }> = {};

	for (const page of pages) {
		for (const translation of page.translatedRoutes) {
			const locale = result[translation.languageCode] || { culture: translation.culture, urls: [] };
			locale.urls.push(translation.path);
			result[translation.languageCode] = locale;
		}
	}

	return result;
}
